import { connect } from 'react-redux';
import { fetchReferrals } from 'marketing/ducks';
import ReferAFriend from 'marketing/components/refer_a_friend';

const mapStateToProps = ({ marketing, user }) => {
  const { referrals } =  marketing;

  return {
    referrals,
    billingName: user.profile_data.billing_name
  };
}

export default connect(mapStateToProps, { fetchReferrals })(ReferAFriend);



// WEBPACK FOOTER //
// ./marketing/containers/refer_a_friend.js